module.exports = __webpack_public_path__ + "static/media/ambusher_effect.03a0c45f.png";